import { render, staticRenderFns } from "./sharinglogin.vue?vue&type=template&id=0cea9d8c&scoped=true&"
import script from "./sharinglogin.vue?vue&type=script&lang=js&"
export * from "./sharinglogin.vue?vue&type=script&lang=js&"
import style0 from "./sharinglogin.vue?vue&type=style&index=0&id=0cea9d8c&prod&lang=css&"
import style1 from "./sharinglogin.vue?vue&type=style&index=1&id=0cea9d8c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea9d8c",
  null
  
)

export default component.exports